import axios from 'axios';

const systemPrefix = process.env.VUE_APP_MODULE_SYSTEM;

export default {
  getMOIFamilyRelation: ({ socialId, dateOfBirth, subSocialId, subDateOfBirth }) =>
    axios.get(`${systemPrefix}/Moi/family-relation/${socialId}/${dateOfBirth}/${subSocialId}/${subDateOfBirth}`),
  getMOIPersonalInfo: (socialId, dateOfBirth, config = {}) =>
    axios.get(`${systemPrefix}/Moi/{encrypt:socialId}/${dateOfBirth}`, { ...config, encryptParams: { socialId } }),
  checkCaptchaRequiredResponse: (config = {}) =>
    axios.get(`${systemPrefix}/Moi/ReCaptcha/check`, config),
  getMOIPersonalInfoByFirstName: (socialId, firstName, config = {}) =>
    axios.get(`${systemPrefix}/Moi/person-info/full-name/${socialId}/${firstName}`, config),
  getPersonalAddress: (socialId, isDefendant) =>
    axios.get(
      isDefendant
        ? `${systemPrefix}/saudi-post/residents/{encrypt:socialId}/address/info`
        : `${systemPrefix}/saudi-post/residents/{encrypt:socialId}/address`,
      { encryptParams: { socialId } }
    ),
  getCompanyInfo: commercialRegistrationNumber =>
    axios.get(`${systemPrefix}/mci/${commercialRegistrationNumber}`),
  getCompanyManager: (commercialRegistrationNumber, socialId, partyType) =>
    axios.get(`${systemPrefix}/mci/${commercialRegistrationNumber}/${socialId}/manager${partyType ? `?partyType=${partyType}` : ''}`),
  getCompanyAddress: commercialRegistrationNumber =>
    axios.get(`${systemPrefix}/saudi-post/companies/${commercialRegistrationNumber}/address`),

  validateInheritor: ({ socialId, judgementCode }) => /*axios.get(`${systemPrefix}/inheritors/${socialId}/${judgementCode}`)*/new Promise((resolve, reject) => {
    setTimeout(() => {
      if (`${judgementCode}`.endsWith('1'))
        resolve();
      else
        reject();
    }, 1000);
  }),
  isDeadPerson: (socialIdType, socialId) => axios.head(`${systemPrefix}/moh/deads/${socialIdType}/${socialId}`),
  validateAgent: socialId => axios.get(`${systemPrefix}/attorneys/${socialId}`),
  validateLawyer: (socialId, isTraineeLawyer, overrideErrorHandlingBehaviour = false) =>
    axios.get(`${systemPrefix}/lawyers/{encrypt:socialId}`,
      {
        params: { isTrainee: isTraineeLawyer },
        overrideErrorHandlingBehaviour: overrideErrorHandlingBehaviour,
        encryptParams: { socialId },
      }),

  validateRegency: payload =>
    axios.head(`${systemPrefix}/TerminationDispute/regency`, { params: payload }),
  validateGuardianship: ({ guardianshipNumber, guardianSocialId, minorSocialId }) =>
    axios.head(
      `${systemPrefix}/custodies/${guardianshipNumber}/${guardianSocialId}/${minorSocialId}`
    ),

  getPrisonerCriminalRecord: (socialId, dateOfBirth) =>
    axios.get(`${systemPrefix}/Prisons/${socialId}/${dateOfBirth}/criminal-record`),
  validateReconciliationCode: ({ reconciliationRequestCode, socialId }) =>
    axios.get(`${systemPrefix}/reconciliation-platform/validate/${reconciliationRequestCode}/${socialId}`),
  getAttorneyDetails: attorneyCode =>
    axios.get(`${systemPrefix}/attorneys/${attorneyCode}/details`),
  validateAttorneyExistence: ({
    attorneyCode, agentSocialId = null, clientSocialId = null, attorneyType = null, excludeCurrentUser = null,
    managerSocialId = null, commercialRegistrationNumber = null, unifiedNumber = null,
  }) =>
    axios.get(`${systemPrefix}/valid-attorneys/${attorneyCode}`,
      {
        params: {
          ...(agentSocialId ? { agentSocialId: agentSocialId } : {}),
          ...(clientSocialId ? { clientSocialId: clientSocialId } : {}),
          ...(attorneyType ? { attorneyType: attorneyType } : {}),
          ...(excludeCurrentUser ? { excludeCurrentUser: excludeCurrentUser } : {}),
          ...(managerSocialId ? { managerSocialId: managerSocialId } : {}),
          ...(commercialRegistrationNumber ? { commercialRegistrationNumber: commercialRegistrationNumber } : {}),
          ...(unifiedNumber ? { unifiedNumber: unifiedNumber } : {}),
        },
      }),
  validateAttorneyExistenceIncludeExternal: ({
    attorneyCode, agentSocialId = null, clientSocialId = null, attorneyType = null, excludeCurrentUser = null,
    managerSocialId = null, commercialRegistrationNumber = null, unifiedNumber = null,
  }) =>
    axios.get(`${systemPrefix}/valid-attorneys-include-external/${attorneyCode}`,
      {
        params: {
          ...(agentSocialId ? { agentSocialId: agentSocialId } : {}),
          ...(clientSocialId ? { clientSocialId: clientSocialId } : {}),
          ...(attorneyType ? { attorneyType: attorneyType } : {}),
          ...(excludeCurrentUser ? { excludeCurrentUser: excludeCurrentUser } : {}),
          ...(managerSocialId ? { managerSocialId: managerSocialId } : {}),
          ...(commercialRegistrationNumber ? { commercialRegistrationNumber: commercialRegistrationNumber } : {}),
          ...(unifiedNumber ? { unifiedNumber: unifiedNumber } : {}),
        },
      }),
  validateTraineeLawyer: socialId => axios.get(`${systemPrefix}/trainees-lawyers/{encrypt:socialId}/validate`, { encryptParams: { socialId } }),
  getContractStatus: leaseRequestNumber => axios.get(`${systemPrefix}/real-estate/contract-status/${leaseRequestNumber}`),
  getCheckContractStatus: leaseRequestNumber => axios.get(`${systemPrefix}/real-estate/check-contract-status/${leaseRequestNumber}`),
  getContractCopy: payload => axios.get(`${systemPrefix}/real-estate/contract-copy/${payload.leaseContractNumber}?leasePartySocialId=${payload.leasePartySocialId}&leaseVersionNumber=${payload.leaseVersionNumber}`),
};
